import { ConfigProvider } from 'antd';
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { LoadingPage } from '../../../pages/etc/LoadingPage/LoadingPage';
import { LayoutProvider } from '../../../provider/LayoutProvider';
import { ToastProvider } from '../../../provider/PopupProvider';
import { NotificationProvider } from '../../../provider/ToastNotificationProvider';
import { store } from '../../../store/store';
import { AppSetup } from './AppSetup';

export const AppBase = () => {
  return (
    <Provider store={store}>
      <ToastProvider>
        <LayoutProvider>
          <ConfigProvider
            theme={{
              token: {
                colorBgMask: 'rgba(0,0,0,0.9)',
              },
            }}
          >
            <NotificationProvider>
              <Suspense fallback={<LoadingPage />}>
                <AppSetup />
              </Suspense>
            </NotificationProvider>
          </ConfigProvider>
        </LayoutProvider>
      </ToastProvider>
    </Provider>
  );
};
